import { ListValue } from '../../data-objects/field-values'
import { DefinitionUtils } from '../utils'
import { FieldDefinition } from './field-definition'

export class ListFieldDefinition extends FieldDefinition {
  public fields: FieldDefinition[]
  public entityName: string
  public autoField: string
  public canAdd: boolean
  public canDelete: boolean
  public hideHeader: boolean
  public showItemsNumber: boolean
  public idmlItem: string
  public descriptionItem: string
  public maxRows: number

  constructor(fields: ListFieldDefinition) {
    super(fields)
    this.fields = DefinitionUtils.mapFieldDefinitions(fields.fields)
    this.entityName = fields.entityName
    this.autoField = fields.autoField
    this.canAdd = fields.canAdd
    this.canDelete = fields.canDelete
    this.hideHeader = fields.hideHeader
    this.showItemsNumber = fields.showItemsNumber
    this.idmlItem = fields.idmlItem
    this.descriptionItem = fields.descriptionItem
    this.maxRows = fields.maxRows
  }

  public getFieldValue(): ListValue {
    return new ListValue()
  }
}
